import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable, { DefaultTableBody } from "mui-datatables";
import { Routes, Route, useNavigate } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";

export default function NewUser() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([""]);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: null,
    email: "",
    roleId: "",
  });
  const { fetchGraphql, DialogSave } = useSave();

  useEffect(() => {
    fetchGraphql({
      query: `query Roles {
      roles {
        roleId
        roleName
      }
    }`,
    }).then((result) =>
      setRoles(
        result.data.roles.map((item) => ({
          label: item.roleName,
          roleId: item.roleId,
        }))
      )
    );
  }, []);
// 
  // console.log(user);

  const handleChangeUser = (e, type) => {
    const copyState = { ...user };

    switch (type) {
      case "firstName":
        copyState.firstName = e.target.value;
        break;
      case "lastName":
        copyState.lastName = e.target.value;
        break;
      case "phoneNumber":
        copyState.phoneNumber = Number(e.target.value);
        break;
      case "email":
        copyState.email = e.target.value;
        break;
      case "role":
        // console.log("value", e);
        copyState.roleId = e.roleId;
        break;
      default:
        break;
    }

    setUser(copyState);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <DialogSave />
      <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <Button
          variant="outlined"
          sx={{ margin: "0px auto 20px 0px" }}
          onClick={() => navigate("/settings/users")}
        >
          <ArrowBackIcon />
          Back
        </Button>
      </Box>
      <Box
        sx={{
          maxWidth: "500px",
          // alignSelf: "center",
          display: "flex",
          // justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        <TextField
          sx={{ margin: "10px", minWidth: "210px" }}
          id="outlined-basic"
          label="First Name"
          value={user.firstName}
          onChange={(e) => handleChangeUser(e, "firstName")}
          variant="outlined"
        />
        <TextField
          sx={{ margin: "10px", minWidth: "210px" }}
          id="outlined-basic"
          label="Last Name"
          value={user.lastName}
          onChange={(e) => handleChangeUser(e, "lastName")}
          variant="outlined"
        />
        <TextField
          sx={{ margin: "10px", minWidth: "210px" }}
          id="outlined-basic"
          label="Phone Number"
          value={user.phoneNumber}
          onChange={(e) => handleChangeUser(e, "phoneNumber")}
          variant="outlined"
        />
        <TextField
          sx={{ margin: "10px", minWidth: "210px" }}
          id="outlined-basic"
          label="Email"
          value={user.email}
          onChange={(e) => handleChangeUser(e, "email")}
          variant="outlined"
        />
        <Autocomplete
          disablePortal
          options={roles}
          sx={{ width: 210, margin: "10px" }}
          // value={user.role}
          // onHighlightChange={(e, value) => handleChangeUser(value, "role")}
          onChange={(e, value) => handleChangeUser(value, "role")}
          renderInput={(params) => <TextField {...params} label="Role" />}
        />
      </Box>
      <Button
        variant="contained"
        sx={{ margin: "auto 0px 0px auto" }}
        onClick={() =>
          fetchGraphql({
            query: `mutation CreateUser($user: userInput) {
                createUser(user: $user)
              }`,
            variables: { user },
          })
        }
      >
        <AddIcon />
        Save User
      </Button>
    </Box>
  );
}
